export default "__VITE_ASSET__DE569azF__"